import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var OFFER_ACTION_TYPES = {
  GENERATE_GALLERY_GRID: 'generate_gallery_grid',
  GENERATE_GALLERY_GRID_SUCCESS: 'generate_gallery_grid_success',
  GET_OFFER_VIEWS_REQUEST: 'get_offer_views_request',
  SET_OFFER_VIEWS: 'set_offer_views',
  SET_OFFER_VIEWS_ERROR: 'set_offer_views_error',
  GET_BOOKINGS_PAID_REQUEST: 'get_bookings_paid_request',
  SET_BOOKINGS_PAID: 'set_bookings_paid',
  SET_BOOKINGS_PAID_ERROR: 'set_bookings_paid_error',
  SET_PRICE_DETAILS_REQUEST: 'set_price_details_request',
  REQUEST_PRICE_DETAILS_DATA: 'request_price_details_data',
  SET_PRICE_DETAILS_DATA: 'set_price_details_data',
  SET_PRICE_DETAILS_DATA_LOADING: 'set_price_details_data_loading',
  SET_PRICE_DETAILS_ERROR: 'set_price_details_error',
  SET_IS_CALENDAR_OPEN: 'set_is_calendar_open'
};
export var generateGalleryGrid = function generateGalleryGrid() {
  return {
    type: OFFER_ACTION_TYPES.GENERATE_GALLERY_GRID
  };
};
export var generateGalleryGridSuccess = function generateGalleryGridSuccess(_ref) {
  var grid = _ref.grid;
  return {
    type: OFFER_ACTION_TYPES.GENERATE_GALLERY_GRID_SUCCESS,
    payload: {
      grid: grid
    }
  };
};
export var setPriceDetailsRequest = function setPriceDetailsRequest(_ref2) {
  var guests = _ref2.guests,
    moveIn = _ref2.moveIn,
    moveOut = _ref2.moveOut,
    optionId = _ref2.optionId;
  return {
    type: OFFER_ACTION_TYPES.SET_PRICE_DETAILS_REQUEST,
    payload: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, guests !== undefined && {
      guests: guests
    }), moveIn !== undefined && {
      moveIn: moveIn
    }), moveOut !== undefined && {
      moveOut: moveOut
    }), optionId !== undefined && {
      optionId: optionId
    })
  };
};
export var requestPriceDetails = function requestPriceDetails() {
  return {
    type: OFFER_ACTION_TYPES.REQUEST_PRICE_DETAILS_DATA
  };
};
export var setPriceDetailsData = function setPriceDetailsData(_ref3) {
  var priceDetails = _ref3.priceDetails;
  return {
    type: OFFER_ACTION_TYPES.SET_PRICE_DETAILS_DATA,
    payload: {
      priceDetails: priceDetails
    }
  };
};
export var setPriceDetailsLoading = function setPriceDetailsLoading(_ref4) {
  var isLoading = _ref4.isLoading;
  return {
    type: OFFER_ACTION_TYPES.SET_PRICE_DETAILS_DATA_LOADING,
    payload: {
      isLoading: isLoading
    }
  };
};
export var setIsCalendarOpenAction = function setIsCalendarOpenAction(_ref5) {
  var isCalendarOpen = _ref5.isCalendarOpen;
  return {
    type: OFFER_ACTION_TYPES.SET_IS_CALENDAR_OPEN,
    payload: {
      isCalendarOpen: isCalendarOpen
    }
  };
};
export var getOfferViews = function getOfferViews(locale) {
  return {
    type: OFFER_ACTION_TYPES.GET_OFFER_VIEWS_REQUEST,
    payload: {
      locale: locale
    }
  };
};
export var setOfferViews = function setOfferViews(offerViews) {
  return {
    type: OFFER_ACTION_TYPES.SET_OFFER_VIEWS,
    payload: {
      offerViews: offerViews
    }
  };
};